export interface FedexZoneType {
	countryName: string
	countryCode: string
	stateName: string
	stateCode: string
	zipMin: string
	zipMax: string
	exportCode:
		| 'A'
		| 'D'
		| 'E'
		| 'F'
		| 'G'
		| 'H'
		| 'I'
		| 'J'
		| 'K'
		| 'M'
		| 'N'
		| 'O'
		| 'P'
		| 'Q'
		| 'R'
		| 'S'
		| 'T'
		| 'U'
		| 'V'
		| 'W'
		| 'X'
		| 'Y'
	isAvailable: boolean
}

export const zoneList: FedexZoneType[] = [
	{
		countryName: 'Afghanistan',
		countryCode: 'AF',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Albania',
		countryCode: 'AL',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: false,
	},
	{
		countryName: 'Algeria',
		countryCode: 'DZ',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'American Samoa',
		countryCode: 'AS',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Andorra',
		countryCode: 'AD',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: false,
	},
	{
		countryName: 'Angola',
		countryCode: 'AO',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Anguilla',
		countryCode: 'AI',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Antigua',
		countryCode: 'AG',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Argentina',
		countryCode: 'AR',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Armenia',
		countryCode: 'AM',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: false,
	},
	{
		countryName: 'Aruba',
		countryCode: 'AW',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Australia',
		countryCode: 'AU',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'U',
		isAvailable: false,
	},
	{
		countryName: 'Austria',
		countryCode: 'AT',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'G',
		isAvailable: false,
	},
	{
		countryName: 'Azerbaijan',
		countryCode: 'AZ',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: false,
	},
	{
		countryName: 'Bahamas',
		countryCode: 'BS',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Bahrain',
		countryCode: 'BH',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Bangladesh',
		countryCode: 'BD',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Barbados',
		countryCode: 'BB',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Barbuda',
		countryCode: 'BB',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Belarus',
		countryCode: 'BY',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: false,
	},
	{
		countryName: 'Belgium',
		countryCode: 'BE',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'M',
		isAvailable: false,
	},
	{
		countryName: 'Belize',
		countryCode: 'BZ',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Benin',
		countryCode: 'BJ',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Bermuda',
		countryCode: 'BM',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Bhutan',
		countryCode: 'BT',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Bolivia',
		countryCode: 'BO',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Bonaire',
		countryCode: 'BQ',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Bosnia-Herzegovina',
		countryCode: 'BA',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: false,
	},
	{
		countryName: 'Botswana',
		countryCode: 'BW',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Brazil',
		countryCode: 'BR',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'British Virgin Islands',
		countryCode: 'VG',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Brunei',
		countryCode: 'BN',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'D',
		isAvailable: false,
	},
	{
		countryName: 'Bulgaria',
		countryCode: 'BG',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: true,
	},
	{
		countryName: 'Burkina Faso',
		countryCode: 'BF',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Burundi',
		countryCode: 'BI',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Cambodia',
		countryCode: 'KH',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'D',
		isAvailable: false,
	},
	{
		countryName: 'Cameroon',
		countryCode: 'CM',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Canada',
		countryCode: 'CA',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'F',
		isAvailable: true,
	},
	{
		countryName: 'Canary Islands',
		countryCode: 'IC',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'M',
		isAvailable: true,
	},
	{
		countryName: 'Cape Verde',
		countryCode: 'CV',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Cayman Islands',
		countryCode: 'KY',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Chad',
		countryCode: 'TD',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Channel Islands',
		countryCode: 'JE',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'M',
		isAvailable: true,
	},
	{
		countryName: 'Chile',
		countryCode: 'CL',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'China (South)',
		countryCode: 'CN',
		stateName: 'Fujian',
		stateCode: 'FJ',
		zipMin: '350000',
		zipMax: '369999',
		exportCode: 'K',
		isAvailable: false,
	},
	{
		countryName: 'China (South)',
		countryCode: 'CN',
		stateName: 'Guangdong',
		stateCode: 'GD',
		zipMin: '510000',
		zipMax: '529999',
		exportCode: 'K',
		isAvailable: false,
	},
	{
		countryName: 'China (Excluding China South)',
		countryCode: 'CN',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'W',
		isAvailable: false,
	},
	{
		countryName: 'Colombia',
		countryCode: 'CO',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Congo',
		countryCode: 'CG',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Congo, Dem Rep Of',
		countryCode: 'CD',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Cook Islands',
		countryCode: 'CK',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Costa Rica',
		countryCode: 'CR',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Croatia',
		countryCode: 'HR',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: true,
	},
	{
		countryName: 'Curacao',
		countryCode: 'CW',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Cyprus',
		countryCode: 'CY',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: true,
	},
	{
		countryName: 'Czech Republic',
		countryCode: 'CZ',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'G',
		isAvailable: true,
	},
	{
		countryName: 'Denmark',
		countryCode: 'DK',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'G',
		isAvailable: true,
	},
	{
		countryName: 'Djibouti',
		countryCode: 'DJ',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Dominica',
		countryCode: 'DM',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Dominican Republic',
		countryCode: 'DO',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'East Timor',
		countryCode: 'TL',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Ecuador',
		countryCode: 'EC',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Egypt',
		countryCode: 'EG',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'El Salvador',
		countryCode: 'SV',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Eritrea',
		countryCode: 'ER',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Estonia',
		countryCode: 'EE',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: true,
	},
	{
		countryName: 'Ethiopia',
		countryCode: 'ET',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Faeroe Islands',
		countryCode: 'FO',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'G',
		isAvailable: false,
	},
	{
		countryName: 'Fiji',
		countryCode: 'FJ',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Finland',
		countryCode: 'FI',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'G',
		isAvailable: true,
	},
	{
		countryName: 'France',
		countryCode: 'FR',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'M',
		isAvailable: false,
	},
	{
		countryName: 'French Guiana',
		countryCode: 'GF',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'French Polynesia',
		countryCode: 'PF',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Gabon',
		countryCode: 'GA',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Gambia',
		countryCode: 'GM',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Georgia',
		countryCode: 'GE',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: false,
	},
	{
		countryName: 'Germany',
		countryCode: 'DE',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'M',
		isAvailable: false,
	},
	{
		countryName: 'Ghana',
		countryCode: 'GH',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Gibraltar',
		countryCode: 'GI',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: false,
	},
	{
		countryName: 'Grand Cayman',
		countryCode: 'KY',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Great Thatch Island',
		countryCode: 'VG',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Great Tobago Islands',
		countryCode: 'VG',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Greece',
		countryCode: 'GR',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'G',
		isAvailable: true,
	},
	{
		countryName: 'Greenland',
		countryCode: 'GL',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'G',
		isAvailable: false,
	},
	{
		countryName: 'Grenada',
		countryCode: 'GD',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Guadeloupe',
		countryCode: 'GP',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Guam',
		countryCode: 'GU',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'D',
		isAvailable: false,
	},
	{
		countryName: 'Guatemala',
		countryCode: 'GT',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Guinea',
		countryCode: 'GN',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Guyana',
		countryCode: 'GY',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Haiti',
		countryCode: 'HT',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Honduras',
		countryCode: 'HN',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Hong Kong',
		countryCode: 'HK',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'V',
		isAvailable: false,
	},
	{
		countryName: 'Hungary',
		countryCode: 'HU',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'G',
		isAvailable: true,
	},
	{
		countryName: 'Iceland',
		countryCode: 'IS',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: false,
	},
	{
		countryName: 'India',
		countryCode: 'IN',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'O',
		isAvailable: false,
	},
	{
		countryName: 'Indonesia',
		countryCode: 'ID',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'T',
		isAvailable: false,
	},
	{
		countryName: 'Iraq',
		countryCode: 'IQ',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Ireland',
		countryCode: 'IE',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'G',
		isAvailable: true,
	},
	{
		countryName: 'Israel',
		countryCode: 'IL',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: true,
	},
	{
		countryName: 'Italy',
		countryCode: 'IT',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'M',
		isAvailable: false,
	},
	{
		countryName: 'Ivory Coast',
		countryCode: 'CI',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Jamaica',
		countryCode: 'JM',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Japan',
		countryCode: 'JP',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'P',
		isAvailable: false,
	},
	{
		countryName: 'Jordan',
		countryCode: 'JO',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Jost Van Dyke Islands',
		countryCode: 'VG',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Kazakhstan',
		countryCode: 'KZ',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: false,
	},
	{
		countryName: 'Kenya',
		countryCode: 'KE',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Kuwait',
		countryCode: 'KW',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Kyrgyzstan',
		countryCode: 'KG',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: false,
	},
	{
		countryName: 'Laos',
		countryCode: 'LA',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'D',
		isAvailable: false,
	},
	{
		countryName: 'Latvia',
		countryCode: 'LV',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: true,
	},
	{
		countryName: 'Lebanon',
		countryCode: 'LB',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Lesotho',
		countryCode: 'LS',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Liberia',
		countryCode: 'LR',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Libya',
		countryCode: 'LY',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Liechtenstein',
		countryCode: 'LI',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'G',
		isAvailable: false,
	},
	{
		countryName: 'Lithuania',
		countryCode: 'LT',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: true,
	},
	{
		countryName: 'Luxembourg',
		countryCode: 'LU',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'G',
		isAvailable: true,
	},
	{
		countryName: 'Macau',
		countryCode: 'MO',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'A',
		isAvailable: false,
	},
	{
		countryName: 'Macedonia',
		countryCode: 'MK',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: false,
	},
	{
		countryName: 'Madagascar',
		countryCode: 'MG',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Malawi',
		countryCode: 'MW',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Malaysia',
		countryCode: 'MY',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'Q',
		isAvailable: false,
	},
	{
		countryName: 'Maldives',
		countryCode: 'MV',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Mali',
		countryCode: 'ML',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Malta',
		countryCode: 'MT',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: true,
	},
	{
		countryName: 'Marshall Islands',
		countryCode: 'MH',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Martinique',
		countryCode: 'MQ',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Mauritania',
		countryCode: 'MR',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Mauritius',
		countryCode: 'MU',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Mexico',
		countryCode: 'MX',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'F',
		isAvailable: true,
	},
	{
		countryName: 'Micronesia',
		countryCode: 'FM',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Moldova',
		countryCode: 'MD',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: true,
	},
	{
		countryName: 'Monaco',
		countryCode: 'MC',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'G',
		isAvailable: false,
	},
	{
		countryName: 'Mongolia',
		countryCode: 'MN',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'D',
		isAvailable: false,
	},
	{
		countryName: 'Montenegro',
		countryCode: 'ME',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: false,
	},
	{
		countryName: 'Montserrat',
		countryCode: 'MS',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Morocco',
		countryCode: 'MA',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Mozambique',
		countryCode: 'MZ',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Namibia',
		countryCode: 'NA',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Nepal',
		countryCode: 'NP',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Netherlands',
		countryCode: 'NL',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'M',
		isAvailable: false,
	},
	{
		countryName: 'Nevis',
		countryCode: 'KN',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'New Caledonia',
		countryCode: 'NC',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'New Zealand',
		countryCode: 'NZ',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'U',
		isAvailable: false,
	},
	{
		countryName: 'Nicaragua',
		countryCode: 'NI',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Niger',
		countryCode: 'NE',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Nigeria',
		countryCode: 'NG',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Norfolk Island',
		countryCode: 'NF',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'U',
		isAvailable: false,
	},
	{
		countryName: 'Norman Island',
		countryCode: 'VG',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Northern Mariana Islands',
		countryCode: 'MP',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Norway',
		countryCode: 'NO',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'G',
		isAvailable: false,
	},
	{
		countryName: 'Oman',
		countryCode: 'OM',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Pakistan',
		countryCode: 'PK',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Palau',
		countryCode: 'PW',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Palestine Autonomous',
		countryCode: 'PS',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Panama',
		countryCode: 'PA',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Papua New Guinea',
		countryCode: 'PG',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Paraguay',
		countryCode: 'PY',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Peru',
		countryCode: 'PE',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Philippines',
		countryCode: 'PH',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'S',
		isAvailable: false,
	},
	{
		countryName: 'Poland',
		countryCode: 'PL',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'G',
		isAvailable: false,
	},
	{
		countryName: 'Portugal',
		countryCode: 'PT',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'G',
		isAvailable: false,
	},
	{
		countryName: 'Puerto Rico',
		countryCode: 'PR',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'F',
		isAvailable: true,
	},
	{
		countryName: 'Qatar',
		countryCode: 'QA',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Reunion',
		countryCode: 'RE',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Romania',
		countryCode: 'RO',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: true,
	},
	{
		countryName: 'Rota',
		countryCode: 'MP',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Russia',
		countryCode: 'RU',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: false,
	},
	{
		countryName: 'Rwanda',
		countryCode: 'RW',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Saba',
		countryCode: 'BQ',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Saipan',
		countryCode: 'MP',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Samoa',
		countryCode: 'WS',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'San Marino',
		countryCode: 'SM',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'M',
		isAvailable: false,
	},
	{
		countryName: 'Saudi Arabia',
		countryCode: 'SA',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Senegal',
		countryCode: 'SN',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Serbia',
		countryCode: 'RS',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: true,
	},
	{
		countryName: 'Seychelles',
		countryCode: 'SC',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Singapore',
		countryCode: 'SG',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'Y',
		isAvailable: false,
	},
	{
		countryName: 'Slovak Republic',
		countryCode: 'SK',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'G',
		isAvailable: false,
	},
	{
		countryName: 'Slovenia',
		countryCode: 'SI',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: true,
	},
	{
		countryName: 'South Africa',
		countryCode: 'ZA',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Spain',
		countryCode: 'ES',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'M',
		isAvailable: false,
	},
	{
		countryName: 'Sri Lanka',
		countryCode: 'LK',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'St. Brthelemy',
		countryCode: 'BL',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'St. Christopher',
		countryCode: 'KN',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'St. Croix Island',
		countryCode: 'VI',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'St. Eustatius',
		countryCode: 'BQ',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'St. John',
		countryCode: 'VI',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'St. Kitts & Nevis',
		countryCode: 'KN',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'St. Lucia',
		countryCode: 'LC',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'St. Maarten',
		countryCode: 'SX',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'St. Martin',
		countryCode: 'MF',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'St. Thomas',
		countryCode: 'VI',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'St. Vincent',
		countryCode: 'VC',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Suriname',
		countryCode: 'SR',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Swaziland',
		countryCode: 'SZ',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Sweden',
		countryCode: 'SE',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'G',
		isAvailable: false,
	},
	{
		countryName: 'Switzerland',
		countryCode: 'CH',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'G',
		isAvailable: true,
	},
	{
		countryName: 'Syria',
		countryCode: 'SY',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Tahiti',
		countryCode: 'PF',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Taiwan',
		countryCode: 'TW',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'X',
		isAvailable: false,
	},
	{
		countryName: 'Tanzania',
		countryCode: 'TZ',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Thailand',
		countryCode: 'TH',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'R',
		isAvailable: false,
	},
	{
		countryName: 'Tinian',
		countryCode: 'MP',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Togo',
		countryCode: 'TG',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Tonga',
		countryCode: 'TO',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Tortola Island',
		countryCode: 'VG',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Trinidad & Tobago',
		countryCode: 'TT',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Tunisia',
		countryCode: 'TN',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Turkey',
		countryCode: 'TR',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: true,
	},
	{
		countryName: 'Turks & Caicos Island',
		countryCode: 'TC',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'U.S. Virgin Islands',
		countryCode: 'VI',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Uganda',
		countryCode: 'UG',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Ukraine',
		countryCode: 'UA',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: false,
	},
	{
		countryName: 'Union Island',
		countryCode: 'VG',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'United Arab Emirates',
		countryCode: 'AE',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'United Kingdom',
		countryCode: 'GB',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'M',
		isAvailable: true,
	},
	{
		countryName: 'USA',
		countryCode: 'US',
		stateName: 'Colorado',
		stateCode: 'CO',
		zipMin: '80000',
		zipMax: '81699',
		exportCode: 'E',
		isAvailable: false,
	},
	{
		countryName: 'USA',
		countryCode: 'US',
		stateName: 'Idaho',
		stateCode: 'ID',
		zipMin: '83200',
		zipMax: '83999',
		exportCode: 'E',
		isAvailable: false,
	},
	{
		countryName: 'USA',
		countryCode: 'US',
		stateName: 'Utah',
		stateCode: 'UT',
		zipMin: '84000',
		zipMax: '84799',
		exportCode: 'E',
		isAvailable: false,
	},
	{
		countryName: 'USA',
		countryCode: 'US',
		stateName: 'Arizona',
		stateCode: 'AZ',
		zipMin: '85000',
		zipMax: '86599',
		exportCode: 'E',
		isAvailable: false,
	},
	{
		countryName: 'USA',
		countryCode: 'US',
		stateName: 'Nevada',
		stateCode: 'NV',
		zipMin: '89000',
		zipMax: '89899',
		exportCode: 'E',
		isAvailable: false,
	},
	{
		countryName: 'USA',
		countryCode: 'US',
		stateName: 'California',
		stateCode: 'CA',
		zipMin: '90000',
		zipMax: '96699',
		exportCode: 'E',
		isAvailable: false,
	},
	{
		countryName: 'USA',
		countryCode: 'US',
		stateName: 'Oregon',
		stateCode: 'OR',
		zipMin: '97000',
		zipMax: '97999',
		exportCode: 'E',
		isAvailable: false,
	},
	{
		countryName: 'USA',
		countryCode: 'US',
		stateName: 'Washington',
		stateCode: 'WA',
		zipMin: '98000',
		zipMax: '99499',
		exportCode: 'E',
		isAvailable: false,
	},
	{
		countryName: 'USA',
		countryCode: 'US',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'F',
		isAvailable: true,
	},
	{
		countryName: 'Uruguay',
		countryCode: 'UY',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: true,
	},
	{
		countryName: 'Uzbekistan',
		countryCode: 'UZ',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'H',
		isAvailable: false,
	},
	{
		countryName: 'Vanuatu',
		countryCode: 'VU',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Vatican City',
		countryCode: 'VA',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'M',
		isAvailable: false,
	},
	{
		countryName: 'Venezuela',
		countryCode: 'VE',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Vietnam',
		countryCode: 'VN',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'N',
		isAvailable: false,
	},
	{
		countryName: 'Wallis & Futuna',
		countryCode: 'WF',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'I',
		isAvailable: false,
	},
	{
		countryName: 'Yemen',
		countryCode: 'YE',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Zambia',
		countryCode: 'ZM',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
	{
		countryName: 'Zimbabwe',
		countryCode: 'ZW',
		stateName: '',
		stateCode: '',
		zipMin: '',
		zipMax: '',
		exportCode: 'J',
		isAvailable: false,
	},
]
